<app-audit-logs
  [headerTextSize]="32"
  [headerDescriptionTmpl]="headerDescriptionTmpl"
></app-audit-logs>

<ng-template #headerDescriptionTmpl>
  <span class="text-14 fw-400 color-gray-500">
    {{ 'tsp-admin.audit-logs.header-description.0' | translate }}
    <a class="text-14 fw-400 color-primary-500" [routerLink]="['/', 'developer-api', 'logs']">
      {{ 'tsp-admin.audit-logs.header-description.1' | translate }}
    </a>
    {{ 'audit-log.logs-stored' | translate: { count: 180 } }}
  </span>
</ng-template>
